import { makeStyles } from "@material-ui/core/styles";

export const lifetimeIncomeCardStyles = makeStyles((theme) => ({
  upgradeMembership: {
    backgroundColor: "#0344DC",
    color: "white",
    borderRadius: "20px",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(16),
    textTransform: "none",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#022984",
    },
    "& .MuiButton-endIcon": {
      color: "#22D9BB",
    },
  },
  card: {
    background: "#F1F5FF",
    borderRadius: "8px",
    margin: "26px 0px",
    padding: "32px 24px",
    height: "84%",
    "& img": {
      marginTop: "15px",
      width: " 100%",
      height: "109px",
    },
  },
  title: {
    fontFamily: "Lato",
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(27.7),
    marginBottom: "15px",
  },
  description: {
    fontFamily: "Lato",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(16),
    color: "#45547C",
    marginBottom: "15px",
  },
}));
